(() => {
    window.circuly = {
        config: {
            apiKey: "xa47NMQldP8SYVt4Q7lr7vYHrSLqcO",
            apiBaseUrl: "https://checkout3.api.circuly.io/v1",
            frontendBaseUrl: "https://checkout.rent.decathlon.be",
            cartId: null,
            debug: true
        },
        logger(...args) {
            const { debug } = this.config;
            if(debug) console.debug("[circuly] ", ...args);
        },
        setCartId(value) {
            this.logger("Setting cart id: ", value)
            this.config.cartId = value;
        },
        routeToCheckout() {
            this.logger("Routing to checkout...")
            const { apiKey, cartId, frontendBaseUrl } = this.config;
            const checkoutUrl = `${frontendBaseUrl}/${apiKey}/${cartId}`
            window.location.href = checkoutUrl;
        },
        async getCart() {
            this.logger("Getting shopify cart...")
            try {
                const cart = await fetch("/cart.js").then(res => res.json());
                // Sanitize cart token by removing query parameters
                if (cart.token) cart.token = cart.token.split('?')[0];
                return cart;
            } catch (error) {
                console.error(error);
            }
        },
        async getServerCart(token) {
            this.logger("Getting server cart...")
            const { apiBaseUrl, apiKey, cartId } = this.config
            try {
                return await fetch(`${apiBaseUrl}/${apiKey}/cart/` + token).then(res => res.json());
            } catch (error) {
                console.error(error);
            }
        },
        async clearCart(){ 
            this.logger("Clearing cart...");
            const cookiesToRemove = [
                'cart',
                '_shopify_s',
                '_shopify_sa_p',
                '_shopify_sa_t',
                '_shopify_y',
                '_shopify_fs',
                '_secure_session_id',
                'storefront_digest'
            ];
            cookiesToRemove.forEach(cookieName => {
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
                if (window.location.hostname.includes('.')) {
                    const parentDomain = '.' + window.location.hostname.split('.').slice(-2).join('.');
                    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${parentDomain}`;
                }
            });       
        },
        async validateCarts() {
            this.logger("Validating carts...")
            let cart = await this.getCart();
            this.logger("cart", cart)
            const serverCart = await this.getServerCart(cart.token);
            this.logger("serverCart", serverCart)
            this.logger("is paid", serverCart.already_paid)
            if(serverCart.already_paid) {
                this.logger("Cart is paid")
                await this.clearCart();
                cart = await this.getCart();
            }
            return { cart, serverCart };
        },
        async handleSubmit() { 
            this.logger("Submitting cart...");
            const { cart } = await this.validateCarts();
            this.logger("token", cart.token)
            this.routeToCheckout();
        },
        getCurrentLanguage() {
            const languageSwitcher = document.querySelector('#language-switcher-ts-control .item[data-value]');
            if (languageSwitcher) {
                return languageSwitcher.getAttribute('data-value');
            }
            // Fallback to default language if not found
            return 'en';
        },
        parseSubscriptionDuration(variantTitle) {
            // Handle null or undefined variant titles
            if (!variantTitle) {
                this.logger("No variant title found, using default duration");
                return 24;
            }
            
            // Parse variant title like "S / 3 months" to extract duration
            const match = variantTitle.match(/(\d+)\s*(?:month|months|mo)/i);
            if (match) {
                return parseInt(match[1], 10);
            }
            // Fallback to default duration if not found
            return 24;
        },
        async createSubscriptionCart() {
            this.logger("Creating subscription cart...");
            try {
                const cart = await this.getCart();
                const { apiBaseUrl, apiKey, cartId, frontendBaseUrl } = this.config;
                
                this.logger(`Processing ${cart.items.length} cart items`);
                
                // First pass: Create a map of bundle IDs to subscription durations from parent items
                const bundleDurations = {};
                cart.items.forEach(item => {
                    if (item.properties && item.properties._bundleRole === 'parent' && item.properties._bundleId) {
                        const duration = this.parseSubscriptionDuration(item.variant_title);
                        bundleDurations[item.properties._bundleId] = duration;
                        this.logger(`Parent bundle ${item.properties._bundleId}: ${item.title} -> ${duration} months`);
                    }
                });
                
                // Second pass: Transform all items, using parent duration for child items
                const items = cart.items.map((item, index) => {
                    let duration;
                    let isSubscription;
                    
                    if (item.properties && item.properties._bundleRole === 'child' && item.properties._bundleId) {
                        // Child item - use parent's duration but set subscription to false
                        duration = bundleDurations[item.properties._bundleId] || 24;
                        isSubscription = false;
                        this.logger(`Item ${index + 1}: ${item.title} (child of bundle ${item.properties._bundleId}) -> ${duration} months, subscription: false`);
                    } else {
                        // Parent item or standalone item - parse its own duration and set subscription to true
                        duration = this.parseSubscriptionDuration(item.variant_title);
                        isSubscription = true;
                        this.logger(`Item ${index + 1}: ${item.title} (${item.variant_title || 'No variant title'}) -> ${duration} months, subscription: true`);
                    }
                    
                    return {
                        sku: item.variant_id,
                        quantity: item.quantity,
                        subscription: isSubscription,
                        subscription_duration: duration,
                        subscription_interval: 1,
                        subscription_period: "monthly",
                        location_id: item.properties?.locationHandle || null
                    };
                });

                this.logger(`Created ${items.length} subscription items`);

                const requestBody = {
                    cart_id: cartId,
                    items: items
                };

                this.logger("Request body:", requestBody);

                const response = await fetch(`${apiBaseUrl}/${apiKey}/cart/${cartId}/create`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                this.logger("Subscription cart created successfully:", result);
                
                // Redirect to Circuly checkout with current language
                const language = this.getCurrentLanguage();
                const checkoutUrl = `${frontendBaseUrl}/${language}/${apiKey}/${cartId}`;
                this.logger("Redirecting to:", checkoutUrl);
                window.location.href = checkoutUrl;
                
                return result;

            } catch (error) {
                console.error("[circuly] Error creating subscription cart:", error);
                throw error;
            }
        },
        async init() { 
            console.info("[circuly] Initialized");
            const { cart } = await this.validateCarts();
            this.setCartId(cart.token);
        }
    };
    setTimeout(() => {
        window.circuly.init();
    }, 50);
})();